import React from 'react';

const SvgSearch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <path d="M11.4114 10.3371H10.8472L10.6472 10.1442C11.5043 9.14422 11.9472 7.77994 11.7043 6.32994C11.3686 4.34423 9.71144 2.75851 7.71144 2.51565C4.69001 2.14422 2.14715 4.68708 2.51858 7.70851C2.76144 9.70851 4.34715 11.3657 6.33287 11.7014C7.78287 11.9442 9.14715 11.5014 10.1472 10.6442L10.34 10.8442V11.4085L13.3757 14.4442C13.6686 14.7371 14.1472 14.7371 14.44 14.4442C14.7329 14.1514 14.7329 13.6728 14.44 13.3799L11.4114 10.3371ZM7.12573 10.3371C5.34715 10.3371 3.91144 8.90137 3.91144 7.1228C3.91144 5.34422 5.34715 3.90851 7.12573 3.90851C8.9043 3.90851 10.34 5.34422 10.34 7.1228C10.34 8.90137 8.9043 10.3371 7.12573 10.3371Z" />
  </svg>
);

export default SvgSearch;
